<div [ngClass]="{'full-width': (!userSubscription?.plan?.recurring && !userSubscription?.isExpired && !userSubscription?.trialBoosterClient) || userSubscription?.type === UserSubscriptionType.REGISTERED, 'canceled': ([userSubscriptionStatus.canceled, userSubscriptionStatus.failed, userSubscriptionStatus.expired].includes(userSubscription.status) || userSubscription?.isExpired), 'db-plan-label-trial': (userSubscription?.plan.type === UserSubscriptionType.FREE && userSubscription?.trialBoosterClient) }"
     class="db-plan-label">
  <div [ngClass]="{'base': userSubscription?.freeBaseClient}" class="db-plan-label__wrap">
    <div *ngIf="!userSubscription?.boosterProClient && (userSubscription?.type !== UserSubscriptionType.FREE || (userSubscription?.type === UserSubscriptionType.FREE && user && (!user?.hasHostingTrial || (user?.hasHostingTrial && user?.hostingTrialExpired)) && !userSubscription?.trialBoosterClient && !userSubscription?.freeBaseClient))"
         class="db-plan-label__wrap-title a">
      <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-title b ">
        Booster {{ userSubscription?.plan?.title }}
      </div>
      <div *ngIf="userSubscription?.trialBoosterClient" class="db-plan-label__wrap-title c">Booster Free</div>

      <!------------------- starter with trial -------------->
      <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && !userSubscription?.trialBoosterClient && user?.hasHostingTrial && !user?.hostingTrialExpired"
           class="db-plan-label__wrap-title db-plan-label__wrap-title-trial">
        Free plan
      </div>
      <div *ngIf="userSubscription?.trialBoosterClient"
           class="db-plan-label__wrap-title db-plan-label__wrap-title-trial">10Web Booster free plan
      </div>

      <!------------------- end starter with trial -------------->

      <div [ngClass]="{'db-plan-label__wrap-body-trial': userSubscription?.type === UserSubscriptionType.FREE || userSubscription?.trialBoosterClient}"
           class="db-plan-label__wrap-body">


        <!------------------- appsumo start || platform start-------------->
        <div>
          <div *ngIf="([UserSubscriptionType.PLATFORM].includes(userSubscription?.type)  || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span>{{ (userSubscription?.plan?.services?.hosting?.domain_count?.parameter_value | DbNumberParseIntPipe) }}
              website{{ ((userSubscription?.plan?.services?.hosting?.domain_count?.parameter_value | DbNumberParseIntPipe) + userSubscription?.plan?.additionalDomainCount) > 1 ? 's' : '' }}</span>
          </div>
          <div *ngIf="([UserSubscriptionType.PLATFORM].includes(userSubscription?.type)  || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span>Automated WordPress hosting</span>
          </div>
          <div *ngIf="([UserSubscriptionType.PLATFORM].includes(userSubscription?.type)  || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span *ngIf="userSubscription?.plan.additionalDomainCount">{{ (userSubscriptionVisits / 1000) }}K monthly visitors</span>
            <span *ngIf="!userSubscription?.plan.additionalDomainCount">{{ (userSubscriptionVisits / 1000) }}K
              monthly visitors</span>
          </div>
          <div *ngIf="([UserSubscriptionType.PLATFORM].includes(userSubscription?.type)  || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE)"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span [innerHTML]="((userSubscription?.plan?.services?.hosting?.hosting_storage?.base_value *
          userSubscription?.plan?.services?.hosting?.domain_count?.parameter_value * 1024 * 1024) | size )+ ' SSD storage'"> </span>
          </div>
          <div *ngIf="(userSubscription?.type === UserSubscriptionType.PLATFORM || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span>{{ 'text_wb_subscription_plan_point1' | dbText }}</span>
          </div>
          <div *ngIf="(userSubscription?.type === UserSubscriptionType.PLATFORM || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span class="db-light">{{ 'text_wb_subscription_plan_point2' | dbText }}</span>
          </div>
          <div *ngIf="(userSubscription?.type === UserSubscriptionType.PLATFORM || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span class="db-light">{{ 'text_wb_subscription_plan_point3' | dbText }}</span>
          </div>
          <div *ngIf="(userSubscription?.type === UserSubscriptionType.PLATFORM || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span [innerHTML]="'text_ltd_subscription_plan_point4' | dbText"></span>
          </div>
          <div *ngIf="(userSubscription?.type === UserSubscriptionType.PLATFORM || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && userSubscription?.plan?.aiBuilderService && !userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>{{ 'generation' | wordsByCount: userSubscription?.plan?.aiBuilderService?.regeneration_count?.parameter_value }}</span>
          </div>
        </div>
        <!------------------- appsumo end || platform end-------------->

        <!------------------- starter with trial -------------->
        <div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">{{ userSubscription?.plan?.services.hosting?.domain_count?.parameter_value }} website
              {{ userSubscription?.plan?.services.hosting?.domain_count?.parameter_value > 1 ? 's' : '' }}</span>
          </div>
          <div
            *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
            class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title db-plan-label__wrap-body-feature-title-free">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">Features</span>
          </div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>AI Builder</span>
          </div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Automated hosting on Google Cloud</span>
          </div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>90+ PageSpeed optimization</span>
          </div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>1-click migration</span>
          </div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.FREE && user?.hasHostingTrial && !userSubscription?.freeBaseClient && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>{{ 'AI generation' | wordsByCount: userSubscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value }}</span>
          </div>
        </div>

        <!------------------- starter with booster -------------->
        <div>
          <div *ngIf="userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span
              class="db-small">{{ userSubscription?.plan?.totalDomainCount >= 1000 ? 'Unlimited' : userSubscription?.plan?.totalDomainCount }}
              optimized websites</span>
          </div>
          <div *ngIf="userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">Homepage + 5 inner pages</span>
          </div>
          <div *ngIf="userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">Full frontend optimization</span>
          </div>
          <div *ngIf="userSubscription?.trialBoosterClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Improve Core Web Vitals</span>
          </div>
          <div *ngIf="userSubscription?.trialBoosterClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>90+ PageSpeed score</span>
          </div>
          <div *ngIf="userSubscription?.trialBoosterClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Caching</span>
          </div>
        </div>
        <!------------------- end starter with trial -------------->

        <!------------------- booster pro start -------------->
        <div>
          <div *ngIf="userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">{{
                (userSubscription?.plan?.totalDomainCount >= 1000 ? 'Unlimited' : userSubscription?.plan?.totalDomainCount) + ' website' +
                (userSubscription?.plan?.totalDomainCount > 1 ? 's' : '')
              }}</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">Full frontend optimization</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature mt10">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Improve Core Web Vitals</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>90+ PageSpeed score</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Caching</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Auto-optimization of unlimited pages & images</span>
          </div>

          <div *ngIf="userSubscription?.boosterProClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-small">Cloudflare Enterprise CDN</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span [innerHTML]="'website' | wordsByCount : userSubscription?.plan?.cdnCountValue"></span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span
              [innerHTML]="((userSubscription?.plan?.cdnBandwidthValue + (userSubscription?.plan?.additionalCDNCount ? (userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) : 0)) | size: {unit: 'MB'}) + ' Bandwidth'"></span>
          </div>

          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>Full page caching on edge network</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>SSL certificate</span>
          </div>
          <div *ngIf="userSubscription?.boosterProClient" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span>DDoS protection and WAF</span>
          </div>
        </div>
        <!------------------- booster pro end -------------->


        <!------------------- bundle start -------------->
        <div>
          <div *ngIf="userSubscription?.type === UserSubscriptionType.PREMIUM || (userSubscription?.type === UserSubscriptionType.FREE && user && (!user?.hasHostingTrial || (user?.hasHostingTrial && user?.hostingTrialExpired))) && !userSubscription?.trialBoosterClient"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span
              class="db-light"><strong>{{ "connected site" | wordsByCount: userSubscription?.plan?.domainCount }}</strong></span>
          </div>

          <div *ngIf="userSubscription?.type === UserSubscriptionType.PREMIUM"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-light"><strong>15+ Premium WordPress Plugins</strong></span>
          </div>

          <div *ngIf="userSubscription?.type === UserSubscriptionType.PREMIUM"
               class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span class="db-light"><strong>30+ Premium Extensions</strong></span>
          </div>
        </div>
        <!------------------- bundle end-------------->


        <!------------------- one product start -------------->

        <div *ngIf="userSubscription?.type === UserSubscriptionType.ONE_PRODUCT"
             class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
          <i class="db-icon db-icon-check"></i>
          <span><strong>{{ _pluginTitle }}</strong></span>
        </div>

        <div *ngIf="userSubscription?.type === UserSubscriptionType.ONE_PRODUCT && planDescriptionInstance">
          <div *ngFor="let feature of planDescriptionInstance?.mainFeatures" class="db-plan-label__wrap-body-feature">
            <i class="db-icon db-icon-circle-sm"></i>
            <span *ngIf="feature" [innerHTML]="feature?.title" class="db-light"></span>
          </div>

          <div class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title">
            <i class="db-icon db-icon-check"></i>
            <span
              class="db-light"><strong>{{ "connected site" | wordsByCount : userSubscription?.plan?.domainCount }}</strong></span>
          </div>
        </div>

        <!------------------- one product end -------------->


      </div>
    </div>
  </div>
</div>
